import React, { useContext, useEffect } from "react";

import { Preview } from "@creatomate/preview";
import styled from "styled-components";

import { IMAGE_TYPE, VIDEO_TYPE } from "../utils/constants";
import { CreatomateContext } from "../contexts/VideoStudioContext";
import { useVideo } from "./ThumbnailsContext";
import TimelineRuler from "./TimelineRuler";
import Playhead from "./Playhead";
import TimelineTracks from "./TimelineTracks";

const Main = styled.div`
  border-radius: 8px;
  height: 100%;
  margin-bottom: 5px;
`;

const Content = styled.div`
  position: relative;
  flex: 1;
  height: auto;
  margin-left: 10px;
  margin-top: -45px;
  padding-top: 40px;
`;

const ContentImages = styled.div`
  position: relative;
  flex: 1;
  height: auto;
`;

interface TimelineContainerProps {
  preview: Preview;
  timelineHeight: number;
  timelineWidth: number;
}

const TimelineContainer: React.FC<TimelineContainerProps> = ({
  preview, timelineHeight, timelineWidth
}) => {
  const { data: { mediaType } } = useContext(CreatomateContext);
  const { cleanUp } = useVideo();

  useEffect(() => () => {
    cleanUp();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Main>
      {mediaType === VIDEO_TYPE && (
        <>
          <div className="TimelineRuler TimelineRuler__hidden">
            <TimelineRuler
              hidden
              preview={preview}
              timelineHeight={timelineHeight}
              timelineWidth={timelineWidth}
            />
          </div>
          <Content>
            <Playhead preview={preview} />
            <TimelineTracks preview={preview} />
          </Content>
        </>
      )}
      {mediaType === IMAGE_TYPE && (
        <ContentImages>
          <TimelineTracks preview={preview} />
        </ContentImages>
      )}
    </Main>
  );
};

export default TimelineContainer;
